
import { Vue, Component, Prop } from "vue-property-decorator";
import VariableIcon from "@/oxygen/variables/VariableIcon.vue";
import TextInput from "@/components/Reusable/CustomInputs/TextInput.vue";
import DropdownInput from "@/components/Reusable/CustomInputs/DropdownInput.vue";
import VariableBoundInput from "@/oxygen/variables/VariableBoundInput.vue";
import DynamicInput from "@/components/Reusable/CustomInputs/DynamicInput.vue";
import CopyButton from "@/components/Reusable/CopyButton.vue";
import DynamicDataChooser from "@/components/Reusable/ControlsTree/DynamicData/DynamicDataChooser.vue";
import {
  createCssVariable,
  createVariableName,
  getAttributesForVariableType,
  getInputForVariableType
} from "@/oxygen/variables/lib/utils";
import { globalStore } from "@/store/store";
import { Variable } from "@/oxygen/variables/lib/types";
import defensiveCopy from "@/util/defensive-copy";
import { DynamicFieldOutput } from "@/types/dynamic-data";
import { isDynamicShortcode } from "@/lib/dynamic-data/utils";
import UnitInput from "@/components/Reusable/CustomInputs/UnitInput/UnitInput.vue";
import ColorInput from "@/components/Reusable/CustomInputs/Color/ColorInput.vue";
import NiceButton from "@/components/UI/NiceButton.vue";
import NumberInput from "@/components/Reusable/CustomInputs/NumberInput.vue";
import FontFamilyInput from "@/components/Reusable/CustomInputs/FontFamily/FontFamilyInput.vue";

@Component({
  components: {
    DynamicDataChooser,
    CopyButton,
    DynamicInput,
    VariableBoundInput,
    DropdownInput,
    TextInput,
    VariableIcon,
    UnitInput,
    ColorInput,
    NiceButton,
    NumberInput,
    FontFamilyInput
  }
})
export default class VariableRepeaterItem extends Vue {
  @Prop()
  variable!: Variable;

  @Prop({ default: false })
  vertical!: boolean;

  @Prop()
  existingVariableIds!: string[];

  get variablesToOverride() {
    return globalStore.variables;
  }

  get cssVariableName() {
    return createCssVariable(this.variable);
  }

  get input() {
    return getInputForVariableType(this.variable.type);
  }

  get attributes() {
    return getAttributesForVariableType(this.variable.type);
  }

  get isDynamicVariable() {
    return isDynamicShortcode(this.variable.value);
  }

  get variablesToOverrideAsItems() {
    return this.variablesToOverride.map(v => ({
      text: v.label,
      value: v.id,
      disabled: this.existingVariableIds?.includes(v.id)
    }));
  }

  updateLabel(newLabel: string | undefined | null) {
    const newVariable = defensiveCopy(this.variable);
    newVariable.label = newLabel || "";
    newVariable.cssVariableName = newVariable.label
      ? createVariableName(newVariable.label)
      : "";

    this.update(newVariable);
  }

  updateValue(newValue: string | undefined | null) {
    const newVariable = defensiveCopy(this.variable);
    newVariable.value = newValue;

    this.update(newVariable);
  }

  setOverrideVariable(newId: string | undefined | null) {
    const newVariable = defensiveCopy(this.variable);
    const globalVariable = this.variablesToOverride.find(v => v.id === newId);

    if (globalVariable && newId) {
      newVariable.id = newId;
      newVariable.type = globalVariable.type;
      newVariable.value = null;
    }

    this.update(newVariable);
  }

  setDynamicData(data: DynamicFieldOutput) {
    const newVariable = defensiveCopy(this.variable);

    newVariable.value = data.shortcode;
    newVariable.dynamicData = data;

    this.$emit("input", newVariable);
  }

  update(variable: Variable) {
    this.$emit("input", variable);
  }
}
